module.exports = __webpack_public_path__ + "static/img/file_unknown.0d339a35.png";